import { Provider } from '@angular/core';
import { ItemStatusService } from './widgets/item-status/item-status.service';
import { CommentsBoxService } from './widgets/comments-box/comments-box.service';
import { DocumentationItemDetailsService } from './widgets/documentation-item-details/documentation-item-details.service';
import { ConfirmModalService } from './modals/confirm-modal/confirm-modal.service';
import { RepositoryService } from '@core/services/repository.service';
import { DocumentsService } from '@core/services/documents.service';
import { DownloadService } from '@core/services/download.service';
import { MainAccountService } from '@core/services/main-account.service';
import { MessagesListService } from '@core/services/messages-list.service';
import { PrintService } from '@core/services/print.service';
import { StampsService } from '@core/services/stamps.service';
import { DraftsService } from '@core/services/drafts.service';

/**
 * Serwisy dostarczane dawniej przez UiModalsModule. Każda leniwa trasa, której moduł importował UiModalsModule,
 * dostaje własne instancje — tak jak wcześniej injector leniwego modułu.
 */
export const UI_MODALS_PROVIDERS: Provider[] = [
  ItemStatusService,
  CommentsBoxService,
  DocumentationItemDetailsService,
  ConfirmModalService,
  RepositoryService,
  DocumentsService,
  DownloadService,
  MainAccountService,
  MessagesListService,
  PrintService,
  StampsService,
  DraftsService,
];
